import { FC } from 'react';
import { Dropdown, DropdownListItem, FInter, FlexBox, Colors, useIsMobile } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import {HoverItemWithSvg, ProjectSearchBarRoot} from './style';
import { useTheme } from 'styled-components';
import { STATUSES } from '_competition/const';
import { OptionProps } from '_competition/pages/AllCompetitionsPage/types';
import { HoverItemText, SortSmallTextDiv } from 'shared/components/projectsSearchBar/style';
import { DropdownText } from 'shared/navbars/components/contextTabsItems';

export const CompetitionDropdown: FC<{
    selectedSorting: STATUSES;
    onSortingChange: (sorting: OptionProps) => void;
    sortingMethods: OptionProps[];
    isDarkTheme?: boolean;
}> = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const defaultValue = props?.sortingMethods[0];
    const isMobile = useIsMobile();

    if (!props.sortingMethods?.length) {
      return null;
    }

    return (
        <ProjectSearchBarRoot align="center">
            <SortSmallTextDiv color={theme.sortByColor} style={{ whiteSpace: 'pre', fontSize: '15px', lineHeight: '20px' }}>{t('competition.show')}</SortSmallTextDiv>
            &nbsp;
            <Dropdown
                dark={props.isDarkTheme}
                offsetArrowX={38}
                orientation='right'
                hideArrow
                target={
                    <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                        <HoverItemText>{t('competition.statuses.' + STATUSES[props?.selectedSorting])}</HoverItemText>
                        <FInter.SmallText>
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                      fill={theme.tags.textColor}/>
                            </svg>
                        </FInter.SmallText>
                    </HoverItemWithSvg>
                }
            >
                    <DropdownListItem onClick={() => props.onSortingChange?.(props?.sortingMethods?.find((i) => i?.identifier === STATUSES.Completed) || defaultValue)}>
                        <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%', color: props.selectedSorting === 5 ? (props.isDarkTheme ? Colors.galBlack61 :'#151514') : 'inherit' }}>
                            <DropdownText className={props.selectedSorting === 5 ? 'active' : ''} isActive={props.selectedSorting === 5} >{t('competition.statuses.Completed')}</DropdownText>
                            {props.selectedSorting === 5 && (
                                <svg
                                    width="32"
                                    height="20"
                                    viewBox="0 0 32 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4064 10.0781L24.0286 13.679L30.6763 7.05256L29.8453 6.22159L24.0286 12.017L21.2161 9.24716L20.4064 10.0781Z"
                                        fill={props.isDarkTheme ? Colors.galBlack61 :'#151514'}
                                    />
                                </svg>
                            )}
                        </FlexBox>
                    </DropdownListItem>

                    <DropdownListItem onClick={() => props.onSortingChange?.(props?.sortingMethods?.find((i) =>i?.identifier === STATUSES.Open) || defaultValue)}>
                        <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%', color: props.selectedSorting === 1 ? (props.isDarkTheme ? Colors.galBlack61 :'#151514') : 'inherit' }}>
                            <DropdownText className={props.selectedSorting === 1 ? 'active' : ''} isActive={props.selectedSorting === 1}>{t('competition.statuses.Open')}</DropdownText>
                            {props.selectedSorting === 1 && (
                                <svg
                                    width="32"
                                    height="20"
                                    viewBox="0 0 32 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4064 10.0781L24.0286 13.679L30.6763 7.05256L29.8453 6.22159L24.0286 12.017L21.2161 9.24716L20.4064 10.0781Z"
                                        fill={props.isDarkTheme ? Colors.galBlack61 :'#151514'}
                                    />
                                </svg>
                            )}
                        </FlexBox>
                    </DropdownListItem>

            </Dropdown>
        </ProjectSearchBarRoot>
    );
};
import { FC } from 'react';
import { Dropdown, DropdownListItem, FInter, FlexBox, Colors, useIsMobile } from '@brg/ui';
import { useTranslation } from 'react-i18next';
import {HoverItemWithSvg, ProjectSearchBarRoot} from './style';
import { useTheme } from 'styled-components';
import { STATUSES } from '_competition/const';
import { OptionProps } from '_competition/pages/AllCompetitionsPage/types';
import { HoverItemText, SortSmallTextDiv } from 'shared/components/projectsSearchBar/style';
import { DropdownText } from 'shared/navbars/components/contextTabsItems';

export const CompetitionDropdown: FC<{
    selectedSorting: STATUSES;
    onSortingChange: (sorting: OptionProps) => void;
    sortingMethods: OptionProps[];
    isDarkTheme?: boolean;
}> = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const defaultValue = props?.sortingMethods[0];
    const isMobile = useIsMobile();

    if (!props.sortingMethods?.length) {
      return null;
    }

    return (
        <ProjectSearchBarRoot align="center">
            <SortSmallTextDiv color={theme.sortByColor} style={{ whiteSpace: 'pre', fontSize: '15px', lineHeight: '20px' }}>{t('competition.show')}</SortSmallTextDiv>
            &nbsp;
            <Dropdown
                dark={props.isDarkTheme}
                offsetArrowX={38}
                orientation='right'
                hideArrow
                target={
                    <HoverItemWithSvg color={theme.sortByColorSort} gx={8}>
                        <HoverItemText>{t('competition.statuses.' + STATUSES[props?.selectedSorting])}</HoverItemText>
                        <FInter.SmallText>
                            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M7 6.15801L1.25981 0.223468C0.971612 -0.0744925 0.504346 -0.0744886 0.216147 0.223475C-0.0720515 0.52144 -0.0720488 1.00453 0.216154 1.30249L6.47817 7.77653C6.76637 8.07449 7.23363 8.07449 7.52183 7.77653L13.7838 1.30249C14.072 1.00453 14.0721 0.52144 13.7839 0.223475C13.4957 -0.0744886 13.0284 -0.0744925 12.7402 0.223468L7 6.15801Z"
                                      fill={theme.tags.textColor}/>
                            </svg>
                        </FInter.SmallText>
                    </HoverItemWithSvg>
                }
            >
                    <DropdownListItem onClick={() => props.onSortingChange?.(props?.sortingMethods?.find((i) => i?.identifier === STATUSES.Completed) || defaultValue)}>
                        <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%', color: props.selectedSorting === 5 ? (props.isDarkTheme ? Colors.galBlack61 :'#151514') : 'inherit' }}>
                            <DropdownText className={props.selectedSorting === 5 ? 'active' : ''} isActive={props.selectedSorting === 5} >{t('competition.statuses.Completed')}</DropdownText>
                            {props.selectedSorting === 5 && (
                                <svg
                                    width="32"
                                    height="20"
                                    viewBox="0 0 32 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4064 10.0781L24.0286 13.679L30.6763 7.05256L29.8453 6.22159L24.0286 12.017L21.2161 9.24716L20.4064 10.0781Z"
                                        fill={props.isDarkTheme ? Colors.galBlack61 :'#151514'}
                                    />
                                </svg>
                            )}
                        </FlexBox>
                    </DropdownListItem>

                    <DropdownListItem onClick={() => props.onSortingChange?.(props?.sortingMethods?.find((i) =>i?.identifier === STATUSES.Open) || defaultValue)}>
                        <FlexBox justify={'space-between'} align={'center'} style={{ width: '100%', color: props.selectedSorting === 1 ? (props.isDarkTheme ? Colors.galBlack61 :'#151514') : 'inherit' }}>
                            <DropdownText className={props.selectedSorting === 1 ? 'active' : ''} isActive={props.selectedSorting === 1}>{t('competition.statuses.Open')}</DropdownText>
                            {props.selectedSorting === 1 && (
                                <svg
                                    width="32"
                                    height="20"
                                    viewBox="0 0 32 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M20.4064 10.0781L24.0286 13.679L30.6763 7.05256L29.8453 6.22159L24.0286 12.017L21.2161 9.24716L20.4064 10.0781Z"
                                        fill={props.isDarkTheme ? Colors.galBlack61 :'#151514'}
                                    />
                                </svg>
                            )}
                        </FlexBox>
                    </DropdownListItem>

            </Dropdown>
        </ProjectSearchBarRoot>
    );
};
